import React, { useState } from 'react'
// import Button from '@mui/material/Button';
import leftarrow from "../../assets/Image/leftarrow.png"
import { useHistory } from "react-router";
import { useParams } from "react-router";
import { getEntriesExport } from '../Services/ApiHandler';
import swal from "sweetalert";
import { toast } from 'react-toastify';

import "../../myfin_v2/css/bookclosure.css";
import { Button } from "../../myfin_v2/elements/Button";
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";



const BookcluosureNav = ({
    bookClosureId,
    setCreatePackageModal,
    setSavePresetModal,
    entries,
    selectedEntries
}) => {
    const history = useHistory();

    const { workspaceId, companyId } = useParams();

    const [loading, setLoading] = useState(false)

    const ExportToExcel = () => {
        const format = "excel"
        setLoading(true);
        getEntriesExport(bookClosureId, companyId, format).then((response) => {
            toast.success("Export to excel successfully.")
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'entris_data.xlsx');
            document.body.appendChild(link);

            link.click();

            window.URL.revokeObjectURL(url);
            link.remove();

        }).catch((error) => {
            swal("Error", `Export Error: ${error.response?.data?.error}`, 'error');
        }).finally(() => setLoading(false))
    }
    const breadcrumbItems = [
        {
            label: "Workspace",
            // link: `/bookclosure/${workspaceId}`,
            link: {
                pathname: `/bookclosure/${workspaceId}`,
                state: { redirectFilter: { companyID: companyId } }
            },
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Book closure",
            // link: `/bookclosure/${workspaceId}`,
            link: {
                pathname: `/bookclosure/${workspaceId}`,
                state: { redirectFilter: { companyID: companyId } }
            },
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "View FSCP Posting", link: "", className: "headerLable" },
    ];
    return (
        <>
            <div className="fscp-header">
                <Breadcrumb style="margin-right:auto"
                    addCls={"bgClr1"}
                    items={breadcrumbItems}
                    headerActions={<></>}
                />
                <SearchIcon width={18} height={18} className='mr-1' />
                <FilterIcon width={20} height={20} className='mr-1' />
                {selectedEntries.length > 0 ? (
                    <Button
                        btnColor={buttoncss.secondary}
                        class_={buttoncss.greyBg}
                        label="Create Push Package"
                        onClick={() => { setCreatePackageModal(true) }}
                    />

                ) : (
                    <Button
                        isEnabled={false}
                        btnColor={`${buttoncss.secondary} ${buttoncss.disabledBtn}`}
                        label="Create Push Package"
                    />
                )}
                <Button
                    btnColor={buttoncss.secondary}
                    class_={buttoncss.greyBg}
                    label="View Matrix"
                    onClick={() => history.push(`/matrix/${workspaceId}/${companyId}`)}
                />
                {entries.length > 0 ? (
                    <Button
                        btnColor={buttoncss.secondary}
                        class_= {buttoncss.greyBg}
                        label="Save as Preset"
                        onClick={() => { setSavePresetModal(true) }}
                    />) : (

                    <Button
                        isEnabled={false}
                        btnColor={`${buttoncss.secondary} ${buttoncss.disabledBtn}`}
                        label="Save as Preset"
                    />
                )}
                <Button
                    btnColor={buttoncss.primary}
                    label={loading ? "Generating file ...." : "Export to Excel"}
                    onClick={ExportToExcel}
                />
            </div>
        </>
    )
}

export default BookcluosureNav